/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * ホットスポットを押したときの動作の設定。動作ごとに使う項目だけを入れる（ADR-0022）。
SEEK={time} / VIDEO_TRANSITION={targetNodeKey, startTime?} / EXTERNAL_LINK={url, openInNewTab?}
 */
export interface HotspotActionConfig {
  /** EXTERNAL_LINK: 新しいタブで開くか。省略時は true */
  openInNewTab?: boolean
  /** EXTERNAL_LINK: リンク先 URL（http/https） @example "https://example.com/apply" */
  url?: string
  /** VIDEO_TRANSITION: 遷移先の再生開始位置（秒）。省略時は 0 @example 0 */
  startTime?: number
  /** VIDEO_TRANSITION: 遷移先ノードの nodeKey @example "welfare" */
  targetNodeKey?: string
  /** SEEK: 移動先（秒） @example 20 */
  time?: number
}
